import React from "react";
import Page from "~/shared/Page";
import ControlledForm from "~/shared/form/ControlledForm";
import CheckboxInput from "~/shared/form/CheckboxInput";
import FloatingPanel from "~/shared/FloatingPanel";
import { setUserAccountStatusOverride } from "~/shared/auth-utils";
import FormButton from "~/shared/form/FormButton";
import FormResponse from "~/shared/form/FormResponse";

export default function PhotoVideoReleaseForm() {
    return (
        <Page title="Family Setup">
            <div className="page-container">
                <FloatingPanel title="Photo/Video Release Agreement">
                    <p className="text-start">
                        This document requests your permission for the Georgia Division of Family and
                        Children Services (DFCS) to take and use photographs of your child and other Afterschool Care
                        Program staff. When we tell others the story about the DFCS Afterschool Care Program, it
                        would be helpful to share photographs of the statewide participants. Pictures can enhance
                        people's understanding about who is involved in the program and what activities and services
                        are being conducted. If you have more than one child, this form should be completed for each
                        child participating in the DFCS funded afterschool program.
                    </p>
                    <p className="text-start">
                        If you agree for us to take and use these photographs, our use of them will include, but will not
                        necessarily be limited to the following: publications about the program; recruitment activities to
                        reach additional youth who might participate in the future; and/or reports about the program to
                        supporters and others who are interested in the program’s outcomes.
                        If you have any questions regarding the Photo Release Form, please contact the DFCS
                        Afterschool Care Program at 404-657-4651.
                    </p>
                    <ol className="text-start d-flex flex-column gap-3">
                        <li>
                            I, the undersigned, consent and agree that still photographs, motion pictures, or television presentations
                            in the form of either live or video tape may be made of myself, my child(ren) by the Georgia Division of
                            Family and Children Services.
                        </li>
                        <li>
                            This release gives the Georgia Division of Family and Children Services the right to use the above-listed
                            visual material in conjunction with the teaching, instruction, training, information and education of
                            employees of the Department or the general public.
                        </li>
                        <li>
                            Further, I hereby release the Georgia Division of Family and Children Services and forever discharge
                            any claim of any nature against them as long as the material is used in compliance with the above-stated
                            paragraph 2.
                        </li>
                        <li>
                            I grant this consent as (parent-guardian) a voluntary contribution in the interest of the said reasons listed
                            in paragraph 2.
                        </li>
                        <li>
                            I understand this Photo/Video Release Agreement does not apply to children in foster care. I further
                            understand if my child is in the foster care system within Georgia, they are not allowed to be
                            photographed or included in motion pictures or television.
                        </li>
                    </ol>
                    <ControlledForm post="family/sign-photo-video-agreement" redirect="/" onSuccess={() => setUserAccountStatusOverride("Profile Setup Complete")}>
                        <CheckboxInput label="I agree to the above terms." id="signed" />
                        <FormResponse />
                        <FormButton className="mx-auto mt-4" family submit>Finish Family Profile</FormButton>
                    </ControlledForm>
                </FloatingPanel>
            </div>
        </Page>
    );
}
